export const CONTENT_CLASSNAME = "flex w-[37.5rem] flex-col gap-4 overflow-auto p-6";
